import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("Session check failed:", e?.message || e);
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function login(email, password) {
    try {
      await api.post("/auth/login", { email, password });
      const me = await api.get("/auth/me");
      setUser(me.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch (e) { if (process.env.NODE_ENV !== "production") console.warn("Logout request failed (clearing session anyway):", e?.message || e); }
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
